module.exports = __webpack_public_path__ + "fonts/lato-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Lato/lato-regular-webfont.woff2
// module id = 3431
// module chunks = 0